// import imgOn from "../../../assets/images/on.png"
import imgOn from "../../../assets/images/onIcon.png"
import Chart from "../../../components/Chart.vue"
import * as echarts from "echarts"
import moment from "moment";
import 'moment/locale/zh-cn';
import screenfull from "screenfull";
import worldMapJson from "./data.json"

export default {
  name: "HomeZeki",
  components: { Chart },
  data() {
    return {
      // weather: {},
      // date: '',
      // week: '',
      // weekday: '',
      // time: '',
      iFullScreen: false,

      titles: [
        { title: "平台设备总数", number: "0", new: "今日新增", add: "0", unit: "台" },
        { title: "今日上线台数", number: "0", new: "", add: "", unit: "" },
        { title: "在线台数", number: "0", new: "", add: "", unit: "" },
      ],
      List: [
        { number: "0", text: "客户数", unit: "个" },
        { number: "0", text: "融资车辆", unit: "台" },
        { number: "0", text: "客户自购", unit: "台" },
        { number: "0", text: "长期维保", unit: "台" },
      ],
      isShow: false,
      // show: false,
      // mapData: [],
      worldMapData: [],
      mapOption: {},
      worldMapOption: {},
      totalExpenditure: 0,
      normalCount: 0,
      approachCount: 0,
      expirationCount: 0,
      maintainPartsCost: 0,
      servicePartsCost: 0,
      maintainArtificialCost: 0,
      serviceArtificialCost: 0,
      amountOption: {},
      numberOption: {},
      costOption: {},
      simOption: {},
      leaveOption: {},
      violationOption: {},
      faultOption: {},
      amountData: { Data: [], YearCount: [], LastYearCount: [] },
      sim: 0,
      leave: 0,
      leaveId: null,
      collisionCount: 0,
      speedOverCount: 0,
      overloadCount: 0,
      outPositionCount: 0,
      leaveFenceCount: 0,
      filterPluggingCount: 0,
      lowOilCount: 0,
      lowPowerCount: 0,
      lowLiquidLevelCount: 0,
    };
  },

  created() {
    this.imgLogo = sessionStorage.getItem("logo");
  },
  mounted() {
    // let _this = this;
    // this.timer = setInterval(() => {
    //   _this.date = moment().format("YYYY年MM月DD日");
    //   _this.time = moment().format("HH:mm:ss");
    // }, 100)
    // this.week = moment().format('dddd')
    // this.getWeather()
    this.getWorldMapValue();
    this.getAmountValue();
    this.getFaultValue();
    this.getData();
    this.getSim();
    this.getValue();
  },
  beforeDestroy() {
    const worldMapDom = document.getElementById("worldMap");
    if (worldMapDom && worldMapDom.echartsInstance) {
      worldMapDom.echartsInstance.dispose();
    }
    const leaveDom = document.getElementById("leaveId");
    if (leaveDom && leaveDom.echartsInstance) {
      leaveDom.echartsInstance.dispose();
    }
    const violationDom = document.getElementById("violationId");
    if (violationDom && violationDom.echartsInstance) {
      violationDom.echartsInstance.dispose();
    }
    const faultDom = document.getElementById("faultId");
    if (faultDom && faultDom.echartsInstance) {
      faultDom.echartsInstance.dispose();
    }
  },
  methods: {
    // getLocation() {
    //   return new Promise((resolve, reject) => {
    //     var geolocation1 = new window.BMapGL.Geolocation();
    //     geolocation1.getCurrentPosition(function (r) {
    //       if (this.getStatus() == BMAP_STATUS_SUCCESS) {
    //         var mk = new window.BMapGL.Marker(r.point);
    //         resolve({ longitude: r.point.lng, latitude: r.point.lat })
    //       } else {

    //       }
    //     })
    //   });
    // },
    // async getWeather() {
    //   const data = await this.getLocation()
    //   console.log(data)
    //   let param = {
    //     longitude: data.longitude,
    //     latitude: data.latitude
    //   }
    //   this.$store.dispatch('HomePage/GET_SELECTUSERLOCATION', param).then(res => {
    //     if (res) {
    //       this.weather = res.data.data
    //     }
    //   }).catch(err => { })
    // },
    toggleFullScreen() {
      if (screenfull.isEnabled) {
        if (!screenfull.isFullscreen) {
          this.iFullScreen = !this.iFullScreen;
          screenfull.request();
        } else {
          this.iFullScreen = !this.iFullScreen;
          screenfull.exit();
        }
      } else {
        this.$message({ message: this.$t('HomPage.form.yourBrowserDoesNotSupportFullScreen'), type: "warning" });
      }
    },
    btnEnter() {
      this.$router.push('/VehicleManagement/VehicleFiles')
    },

    // showBtn() {
    //   this.isShow = !this.isShow;
    // },
    getWorldMapValue() {
      this.worldMapData = [];
      let param = {
        orgId: sessionStorage.getItem("roleData")
      }
      this.$store.dispatch('HomeZeki/GET_GETCOUNTRYCARCOUNT', param).then(res => {
        if (res) {
          if (res.data.code == 200) {
            this.worldMapData = res.data.data;
            this.getWorldMap(this.worldMapData, 2);
          }
        }
      }).catch(err => { })
    },
    getWorldMap(worldMapData, type) {
      let myChart = echarts.init(document.getElementById("worldMap"));
      var uploadedDataURL = "/worldData.json";
      myChart.showLoading();
      // myChart.on("click", (e) => {
      //   var lng = e.data.lng;
      //   var lat = e.data.lat;
      //   var name = e.data.name;
      //   if (e.data) {
      //     this.$router.push({
      //       path: "/VehicleManagement/VehicleDistribution",
      //       query: { lng: lng, lat: lat, name: name, type: type },
      //     });
      //   }
      // });
      $.getJSON(uploadedDataURL, (geoJson) => {
        echarts.registerMap("world", geoJson);
        myChart.hideLoading();
        var geoCoordMap = worldMapJson;
        var data = [];
        var data_en = [];
        worldMapData & worldMapData.map((item) => {
          data.push({
            name: item.country,
            value: Number(item.provinceCarCount),
          });
          data_en.push({
            name: item.countryEn,
            value: Number(item.provinceCarCount),
          });
        });
        var convertData = function (data) {
          var res = [];
          for (var i = 0; i < data.length; i++) {
            var geoCoord = geoCoordMap[data[i].name];
            if (geoCoord) {
              res.push({
                name: data[i].name,
                value: geoCoord.concat(data[i].value),
                lng: geoCoord[0],
                lat: geoCoord[1],
              });
            }
          }
          return res;
        };

        let option = {
          title: {
            top: 20,
            subtext: "",
            x: "center",
            textStyle: { color: "#ccc" },
          },
          tooltip: {
            trigger: "item",
            formatter: function (params) {
              if (typeof params.value[2] == "undefined") {
                if (typeof params.data == "undefined") {
                  return params.name + " : " + '0';
                } else {
                  return params.name + " : " + params.value;
                }
              } else {
                return params.name + " : " + params.value[2];
              }
            },
          },
          legend: {
            orient: "vertical",
            y: "bottom",
            x: "right",
            data: ["pm2.5"],
            textStyle: { color: "#fff" },
          },
          visualMap: {
            show: false,
            min: 0,
            max: 500,
            left: "left",
            top: "bottom",
            text: ["高", "低"],
            calculable: true,
            seriesIndex: [1],
            inRange: {},
          },
          geo: {
            map: "world",
            show: true,
            roam: true,
            label: {
              normal: { show: false },
              emphasis: { show: false },
            },
            itemStyle: {
              normal: {
                areaColor: "#3a7fd5",
                borderColor: "#0a53e9",
                shadowColor: "#092f8f",
                shadowBlur: 20,
              },
              emphasis: { areaColor: "#0a2dae" },
            },
          },
          series: [
            {
              symbolSize: 5,
              label: {
                normal: {
                  formatter: "{b}",
                  position: "right",
                  show: true,
                },
                emphasis: { show: true },
              },
              itemStyle: { normal: { color: "#fff" } },
              name: "light",
              type: "scatter",
              coordinateSystem: "geo",
              data: convertData(data),
            },
            {
              type: "map",
              map: "world",
              geoIndex: 0,
              aspectScale: 0.75,
              showLegendSymbol: false,
              label: {
                normal: { show: false },
                emphasis: { show: false, textStyle: { color: "#fff" } },
              },
              roam: true,
              zoom: 1.2,
              itemStyle: {
                normal: { areaColor: "#031525", borderColor: "#FFFFFF" },
                emphasis: { areaColor: "#2B91B7" },
              },
              animation: false,
              data: data_en,
            },
            {
              name: "Top 5",
              type: "effectScatter",
              coordinateSystem: "geo",
              symbol: "pin",
              symbolSize: [35, 35],
              label: {
                normal: {
                  show: true,
                  textStyle: { color: "#0a2dae", fontSize: 10 },
                  formatter(value) {
                    return value.data.value[2];
                  },
                },
              },
              itemStyle: { normal: { color: "#18ffff" } },
              data: convertData(data),
              showEffectOn: "render",
              rippleEffect: { brushType: "stroke" },
              hoverAnimation: true,
              zlevel: 1,
            },
          ],
        };
        myChart.setOption(option);
      });
    },
    getAmountValue() {
      this.amountData = { Data: [], YearCount: [], LastYearCount: [] };
      let param = {
        orgId: sessionStorage.getItem("roleData")
      }
      this.$store.dispatch('HomeZeki/GET_CARCOUNTCONTRAST', param).then(res => {
        if (res) {
          if (res.data.code == 200) {
            res.data.data.map((item) => {
              this.amountData.Data.push(item.date);
              this.amountData.YearCount.push(item.thisYearCarCount == null ? 0 : item.thisYearCarCount);
              this.amountData.LastYearCount.push(item.lastYearCarCount == null ? 0 : item.lastYearCarCount);
            });
            this.getAmount(this.amountData);
          }
        }
      }).catch(err => { })
    },
    getAmount(amountData) {
      this.amountOption = {
        title: {
          text: "自持设备变化趋势图",
          top: 4,
          left: "center",
          textStyle: { color: "#fff", fontSize: 15, fontWeight: 500 },
        },
        tooltip: { trigger: "axis" },
        legend: {
          left: "center",
          data: ["去年车辆数", "今年车辆数"],
          top: "30",
          itemWidth: 15,
          itemHeight: 15,
          textStyle: { color: "#fff" },
        },
        xAxis: {
          type: "category",
          boundaryGap: true,
          axisTick: { show: false },
          axisLine: { lineStyle: { color: "#fff" } },
          axisLabel: { textStyle: { color: "#fff" } },
          splitLine: { show: false },
          data: amountData.Data,
        },
        grid: { bottom: 30, left: 70, right: 30, top: 90 },
        yAxis: [
          {
            type: "value",
            name: "数量",
            nameTextStyle: { color: "white" },
            axisTick: { show: false },
            axisLabel: { color: "#fff" },
            splitLine: {
              show: true,
              lineStyle: { color: ["rgba(173,177,195,.1)"], type: "dashed" },
            },
          },
        ],
        series: [
          {
            name: "去年车辆数",
            data: amountData.LastYearCount,
            type: "bar",
            barCategoryGap: "40%",
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#16e1ff" },
                  { offset: 1, color: "#1ee2ff" },
                ]),
              },
            },
          },
          {
            name: "今年车辆数",
            data: amountData.YearCount,
            type: "bar",
            barCategoryGap: "40%",
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#007cfc" },
                  { offset: 1, color: "#409eff" },
                ]),
              },
            },
          },
        ],
      };
    },
    getFaultValue() {
      let param = {
        orgId: sessionStorage.getItem("roleData")
      }
      this.$store.dispatch('HomeZeki/GET_GETMAINTENANCE', param).then(res => {
        if (res) {
          if (res.data.code == 200) {
            this.totalExpenditure = res.data.data.monthlyExpenditure;
            this.normalCount = res.data.data.normalCount;
            this.approachCount = res.data.data.approachCount;
            this.expirationCount = res.data.data.expirationCount;
            this.maintainPartsCost = res.data.data.maintainPartsCost;
            this.servicePartsCost = res.data.data.servicePartsCost;
            this.maintainArtificialCost = res.data.data.maintainArtificialCost;
            this.serviceArtificialCost = res.data.data.serviceArtificialCost;
            this.getNumber(this.normalCount, this.approachCount, this.expirationCount);
            this.getCost(
              this.maintainPartsCost,
              this.servicePartsCost,
              this.maintainArtificialCost,
              this.serviceArtificialCost
            );
          }
        }
      }).catch(err => { })
    },
    getNumber(normalCount, approachCount, expirationCount) {
      this.numberOption = {
        title: {
          text: "维修保养台数占比",
          top: 5,
          right: 20,
          textStyle: { color: "#18ffff", fontSize: 15, fontWeight: 500 },
        },
        color: ["#67C23A", "#E6A23C", "#F56C6C"],
        tooltip: { trigger: "item", formatter: "{a} <br/>{b} : {c} ({d}%)" },
        legend: {
          orient: "vertical",
          right: "2%",
          bottom: "10%",
          itemWidth: 20,
          itemHeight: 8,
          itemGap: 20,
          textStyle: {
            rich: {
              name: { fontSize: 12, color: "#18ffff" },
              value: { fontSize: 16, padding: [0, 5], color: "#18ffff" },
              unit: { fontSize: 12 },
            },
          },
          formatter: (name) => {
            let data = [
              { value: approachCount, name: "保养临期" },
              { value: expirationCount, name: "保养超期" },
              { value: normalCount, name: "正常" },
            ];
            let res = data.filter((v) => v.name === name);
            res = res[0] || {};
            return "{name|" + name + "}  {value|" + res.value + "}{unit|}";
          },
        },
        series: [
          {
            name: "维修保养费用占比",
            type: "pie",
            radius: ["50%", "70%"],
            center: ["33%", "50%"],
            label: { formatter: "{d}%" },
            labelLine: { length: 10, length2: 10 },
            data: [
              { value: normalCount, name: "正常" },
              { value: approachCount, name: "保养临期" },
              { value: expirationCount, name: "保养超期" },
            ],
            emphasis: {
              itemStyle: { shadowBlur: 10, shadowOffsetX: 0, shadowColor: "rgba(0, 0, 0, 0.5)" },
            },
          },
        ],
      };
    },
    getCost(maintainPartsCost, servicePartsCost, maintainArtificialCost, serviceArtificialCost) {
      this.costOption = {
        title: {
          text: "故障维修金额占比",
          top: 5,
          right: 20,
          textStyle: { color: "#18ffff", fontSize: 15, fontWeight: 500 },
        },
        tooltip: { trigger: "item", formatter: "{a} <br/>{b} : {c} ({d}%)" },
        legend: {
          orient: "vertical",
          icon: "circle",
          right: "5%",
          bottom: "20%",
          itemWidth: 10,
          itemHeight: 10,
          data: ["保养配件费用", "维修配件费用", "保养人工费用", "维修人工费用"],
          textStyle: { color: "#fft" },
        },
        series: [
          {
            name: "Line 1",
            type: "pie",
            roundCap: true,
            clockWise: false,
            radius: [70, 78],
            center: ["33%", "50%"],
            itemStyle: {
              normal: {
                label: { show: false },
                labelLine: { show: false },
                shadowBlur: 40,
                borderWidth: 10,
                shadowColor: "rgba(0, 0, 0, 0)",
              },
            },
            hoverAnimation: false,
            startAngle: 90,
            data: [
              {
                value: serviceArtificialCost,
                name: "维修人工费用",
                itemStyle: { normal: { color: "#f3a99a" } },
              },
              {
                value: maintainArtificialCost + maintainPartsCost + serviceArtificialCost + servicePartsCost,
                name: "",
                tooltip: { show: false },
                itemStyle: {
                  normal: { color: "#0b347c", label: { show: false }, labelLine: { show: false } },
                  emphasis: { color: "#0b347c" },
                },
              },
            ],
          },
          {
            name: "Line 2",
            type: "pie",
            clockWise: false,
            radius: [50, 58],
            center: ["33%", "50%"],
            itemStyle: {
              normal: {
                label: { show: false },
                labelLine: { show: false },
                shadowBlur: 40,
                borderWidth: 10,
                shadowColor: "rgba(0, 0, 0, 0)",
              },
            },
            hoverAnimation: false,
            startAngle: 90,
            data: [
              {
                value: maintainArtificialCost,
                name: "保养人工费用",
                itemStyle: { normal: { color: "#e09fd9" } },
              },
              {
                value: maintainArtificialCost + maintainPartsCost + serviceArtificialCost + servicePartsCost,
                name: "",
                tooltip: { show: false },
                itemStyle: {
                  normal: { color: "#0b347c", label: { show: false }, labelLine: { show: false } },
                  emphasis: { color: "#0b347c" },
                },
              },
            ],
          },
          {
            name: "Line 3",
            type: "pie",
            clockWise: false,
            radius: [30, 38],
            center: ["33%", "50%"],
            itemStyle: {
              normal: {
                label: { show: false },
                labelLine: { show: false },
                shadowBlur: 40,
                borderWidth: 10,
                shadowColor: "rgba(0, 0, 0, 0)",
              },
            },
            hoverAnimation: false,
            startAngle: 90,
            data: [
              {
                value: servicePartsCost,
                name: "维修配件费用",
                itemStyle: { normal: { color: "#8196e8" } },
              },
              {
                value: maintainArtificialCost + maintainPartsCost + serviceArtificialCost + servicePartsCost,
                name: "",
                tooltip: { show: false },
                itemStyle: {
                  normal: { color: "#0b347c", label: { show: false }, labelLine: { show: false } },
                  emphasis: { color: "#0b347c" },
                },
              },
            ],
          },
          {
            name: "Line 4",
            type: "pie",
            clockWise: false,
            radius: [10, 18],
            center: ["33%", "50%"],
            itemStyle: {
              normal: {
                label: { show: false },
                labelLine: { show: false },
                shadowBlur: 40,
                borderWidth: 10,
                shadowColor: "rgba(0, 0, 0, 0)",
              },
            },
            hoverAnimation: false,
            startAngle: 90,
            data: [
              {
                value: maintainPartsCost,
                name: "保养配件费用",
                itemStyle: { normal: { color: "#80c4e7" } },
              },
              {
                value: maintainArtificialCost + maintainPartsCost + serviceArtificialCost + servicePartsCost,
                name: "",
                tooltip: { show: false },
                itemStyle: {
                  normal: { color: "#0b347c", label: { show: false }, labelLine: { show: false } },
                  emphasis: { color: "#0b347c" },
                },
              },
            ],
          },
        ],
      };
    },
    getData() {
      let param = {
        orgId: sessionStorage.getItem("roleData")
      }
      this.$store.dispatch('HomeZeki/GET_GETSTATISTICALDATA', param).then(res => {
        if (res) {
          if (res.data.code == 200) {
            this.titles[0].number = res.data.data.platformCarCount;
            this.titles[0].add = res.data.data.addCarCount;
            this.titles[1].number = res.data.data.onlineCarCount;
            this.titles[2].number = res.data.data.linkCarCount;
            // this.List[0].number = res.data.clientCount;
            // this.List[1].number = res.data.financeCarCount;
            // this.List[2].number = res.data.haveCarCount;
            // this.List[3].number = res.data.repairCarCount;
            this.leave = res.data.data.leaveCloudFenceCount;
            this.leaveId = res.data.data.leaveCloudFenceId;
            this.getLeave(this.leave, this.leaveId);
          }
        }
      }).catch(err => { })
    },
    getSim() {
      var sim = [0];
      this.simOption = {
        // title: {
        //   text: "SIM卡拔出" + sim,
        //   textStyle: { color: "#fff", fontSize: 12 },
        //   right: "20%",
        //   bottom: "10%",
        // },
        tooltip: {
          formatter: function (params) {
            return '<span style="color: #333;">SIM卡拔出：' + sim + "</span>";
          },
        },
        angleAxis: { max: 100, clockwise: true, show: false },
        radiusAxis: {
          type: "category",
          show: true,
          axisLabel: { show: false },
          axisLine: { show: false },
          axisTick: { show: false },
        },
        polar: { center: ["50%", "50%"], radius: "100%" },
        series: [
          {
            type: "bar",
            data: sim,
            showBackground: true,
            backgroundStyle: { color: "#1262af" },
            coordinateSystem: "polar",
            roundCap: true,
            barWidth: 15,
            itemStyle: {
              normal: {
                opacity: 1,
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#f29999" },
                  { offset: 1, color: "#f29999" },
                ]),
              },
            },
          },
        ],
      };
    },
    getLeave(leave, leaveId) {
      let myLeave = echarts.init(document.getElementById("leaveId"));
      var region = [leave];
      this.leaveOption = {
        // title: {
        //   text: "离开风险区域" + region,
        //   textStyle: { color: "#fff", fontSize: 12 },
        //   left: "20%",
        //   bottom: "10%",
        // },
        tooltip: {
          formatter: function (params) {
            return '<span style="color: #333;">离开风险区域：' + region + "</span>";
          },
        },
        angleAxis: { max: 100, clockwise: true, show: false },
        radiusAxis: {
          type: "category",
          show: true,
          axisLabel: { show: false },
          axisLine: { show: false },
          axisTick: { show: false },
        },
        polar: { center: ["50%", "50%"], radius: "100%" },
        series: [
          {
            type: "bar",
            data: region,
            showBackground: true,
            backgroundStyle: { color: "#1262af" },
            coordinateSystem: "polar",
            roundCap: true,
            barWidth: 15,
            itemStyle: {
              normal: {
                opacity: 1,
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#f6ea9c" },
                  { offset: 1, color: "#f6ea9c" },
                ]),
              },
            },
          },
        ],
      };
      myLeave.setOption(this.leaveOption);
    },
    leaveClick() {
      this.$router.push({
        name: "OpsAlarm",
        params: { leaveId: this.leaveId },
      });
    },
    getValue() {
      let param = {
        orgId: sessionStorage.getItem("roleData")
      }
      this.$store.dispatch('HomeZeki/GET_GETDAYVIOLATIONANDMALFUNCTION', param).then(res => {
        if (res) {
          if (res.data.code == 200) {
            this.collisionCount = res.data.data.collisionCount;
            this.speedOverCount = res.data.data.speedOverCount;
            this.overloadCount = res.data.data.overloadCount;
            this.outPositionCount = res.data.data.outPositionCount;
            this.leaveFenceCount = res.data.data.leaveFenceCount;
            this.filterPluggingCount = res.data.data.filterPluggingCount;
            this.lowOilCount = res.data.data.lowOilCount;
            this.lowPowerCount = res.data.data.lowPowerCount;
            this.lowLiquidLevelCount = res.data.data.lowLiquidLevelCount;
            this.getViolation(
              this.collisionCount,
              this.speedOverCount,
              this.overloadCount,
              this.outPositionCount,
              this.leaveFenceCount
            );
            this.getFault(
              this.filterPluggingCount,
              this.lowOilCount,
              this.lowPowerCount,
              this.lowLiquidLevelCount
            );
          }
        }
      }).catch(err => { })
    },
    getViolation(collisionCount, speedOverCount, overloadCount, outPositionCount, leaveFenceCount) {
      let myLine = echarts.init(document.getElementById("violationId"));
      const CubeLeft = echarts.graphic.extendShape({
        shape: { x: 0, y: 0 },
        buildPath: function (ctx, shape) {
          const xAxisPoint = shape.xAxisPoint;
          const c0 = [shape.x, shape.y];
          const c1 = [shape.x - 10, shape.y - 10];
          const c2 = [xAxisPoint[0] - 10, xAxisPoint[1] - 10];
          const c3 = [xAxisPoint[0], xAxisPoint[1]];
          ctx.moveTo(c0[0], c0[1]).lineTo(c1[0], c1[1]).lineTo(c2[0], c2[1]).lineTo(c3[0], c3[1]).closePath();
        },
      });
      const CubeRight = echarts.graphic.extendShape({
        shape: { x: 0, y: 0 },
        buildPath: function (ctx, shape) {
          const xAxisPoint = shape.xAxisPoint;
          const c1 = [shape.x, shape.y];
          const c2 = [xAxisPoint[0], xAxisPoint[1]];
          const c3 = [xAxisPoint[0] + 14, xAxisPoint[1] - 6];
          const c4 = [shape.x + 14, shape.y - 6];
          ctx.moveTo(c1[0], c1[1]).lineTo(c2[0], c2[1]).lineTo(c3[0], c3[1]).lineTo(c4[0], c4[1]).closePath();
        },
      });
      const CubeTop = echarts.graphic.extendShape({
        shape: { x: 0, y: 0 },
        buildPath: function (ctx, shape) {
          const c1 = [shape.x, shape.y];
          const c2 = [shape.x + 14, shape.y - 6];
          const c3 = [shape.x + 2, shape.y - 16];
          const c4 = [shape.x - 10, shape.y - 10];
          ctx.moveTo(c1[0], c1[1]).lineTo(c2[0], c2[1]).lineTo(c3[0], c3[1]).lineTo(c4[0], c4[1]).closePath();
        },
      });
      echarts.graphic.registerShape("CubeLeft", CubeLeft);
      echarts.graphic.registerShape("CubeRight", CubeRight);
      echarts.graphic.registerShape("CubeTop", CubeTop);
      this.violationOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: { type: "shadow" },
          formatter: function (params) {
            const item = params[1];
            return item.name + " : " + item.value;
          },
        },
        title: {
          text: "当前违规",
          top: 4,
          left: "center",
          textStyle: { color: "#fff", fontSize: 15, fontWeight: 500 },
        },
        grid: { left: 40, right: 40, bottom: 30, top: 80, containLabel: true },
        xAxis: {
          type: "category",
          data: ["碰撞", "超速", "超载", "离位超时", "出电子围栏"],
          axisLine: { show: false, lineStyle: { color: "white" } },
          offset: 0,
          axisTick: { show: false, length: 9, alignWithLabel: true, lineStyle: { color: "#7DFFFD" } },
          axisLabel: { show: true, fontSize: 10, interval: 0 },
        },
        yAxis: {
          type: "value",
          axisLine: { show: false, lineStyle: { color: "white" } },
          splitLine: { show: false },
          axisTick: { show: false },
          axisLabel: { show: false, fontSize: 16 },
          boundaryGap: ["20%", "20%"],
        },
        series: [
          {
            type: "custom",
            renderItem: function (params, api) {
              const location = api.coord([api.value(0), api.value(1)]);
              return {
                type: "group",
                children: [
                  {
                    type: "CubeLeft",
                    shape: { api, x: location[0], y: location[1], xAxisPoint: api.coord([api.value(0), 0]) },
                    style: { fill: "rgba(47,102,192,.27)" },
                  },
                  {
                    type: "CubeRight",
                    shape: { api, x: location[0], y: location[1], xAxisPoint: api.coord([api.value(0), 0]) },
                    style: { fill: "rgba(59,128,226,.27)" },
                  },
                  {
                    type: "CubeTop",
                    shape: { api, x: location[0], y: location[1], xAxisPoint: api.coord([api.value(0), 0]) },
                    style: { fill: "rgba(72,156,221,.27)" },
                  },
                ],
              };
            },
            data: [3000, 3000, 3000, 3000, 3000],
          },
          {
            type: "custom",
            renderItem: (params, api) => {
              const location = api.coord([api.value(0), api.value(1)]);
              var color = api.value(1) > 2000
                ? "red"
                : new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "yellow" },
                  { offset: 1, color: "yellow" },
                ]);
              return {
                type: "group",
                children: [
                  {
                    type: "CubeLeft",
                    shape: {
                      api,
                      xValue: api.value(0),
                      yValue: api.value(1),
                      x: location[0],
                      y: location[1],
                      xAxisPoint: api.coord([api.value(0), 0]),
                    },
                    style: { fill: color },
                  },
                  {
                    type: "CubeRight",
                    shape: {
                      api,
                      xValue: api.value(0),
                      yValue: api.value(1),
                      x: location[0],
                      y: location[1],
                      xAxisPoint: api.coord([api.value(0), 0]),
                    },
                    style: { fill: color },
                  },
                  {
                    type: "CubeTop",
                    shape: {
                      api,
                      xValue: api.value(0),
                      yValue: api.value(1),
                      x: location[0],
                      y: location[1],
                      xAxisPoint: api.coord([api.value(0), 0]),
                    },
                    style: {
                      fill: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        { offset: 0, color: "rgba(47,102,192,.27)" },
                        { offset: 1, color: "rgba(47,102,192,.27)" },
                      ]),
                    },
                  },
                ],
              };
            },
            data: [collisionCount, speedOverCount, overloadCount, outPositionCount, leaveFenceCount],
          },
          {
            type: "bar",
            label: {
              normal: {
                show: true,
                position: "top",
                fontSize: 14,
                color: "#15cbdb",
                offset: [2, -60],
                formatter: function (params) {
                  return params.value + " 次";
                },
              },
            },
            itemStyle: { color: "transparent" },
            tooltip: {},
            data: [collisionCount, speedOverCount, overloadCount, outPositionCount, leaveFenceCount],
          },
        ],
      };
      myLine.setOption(this.violationOption);
      myLine.on("click", (e) => {
        var name = e.name;
        if (name) {
          this.$router.push({ name: "ViolationControl", params: { name: name } });
        }
      });
    },
    getFault(filterPluggingCount, lowOilCount, lowPowerCount, lowLiquidLevelCount) {
      let myLine = echarts.init(document.getElementById("faultId"));
      const CubeLeft = echarts.graphic.extendShape({
        shape: { x: 0, y: 0 },
        buildPath: function (ctx, shape) {
          const xAxisPoint = shape.xAxisPoint;
          const c0 = [shape.x, shape.y];
          const c1 = [shape.x - 10, shape.y - 10];
          const c2 = [xAxisPoint[0] - 10, xAxisPoint[1] - 10];
          const c3 = [xAxisPoint[0], xAxisPoint[1]];
          ctx.moveTo(c0[0], c0[1]).lineTo(c1[0], c1[1]).lineTo(c2[0], c2[1]).lineTo(c3[0], c3[1]).closePath();
        },
      });
      const CubeRight = echarts.graphic.extendShape({
        shape: { x: 0, y: 0 },
        buildPath: function (ctx, shape) {
          const xAxisPoint = shape.xAxisPoint;
          const c1 = [shape.x, shape.y];
          const c2 = [xAxisPoint[0], xAxisPoint[1]];
          const c3 = [xAxisPoint[0] + 14, xAxisPoint[1] - 6];
          const c4 = [shape.x + 14, shape.y - 6];
          ctx.moveTo(c1[0], c1[1]).lineTo(c2[0], c2[1]).lineTo(c3[0], c3[1]).lineTo(c4[0], c4[1]).closePath();
        },
      });
      const CubeTop = echarts.graphic.extendShape({
        shape: { x: 0, y: 0 },
        buildPath: function (ctx, shape) {
          const c1 = [shape.x, shape.y];
          const c2 = [shape.x + 14, shape.y - 6];
          const c3 = [shape.x + 2, shape.y - 16];
          const c4 = [shape.x - 10, shape.y - 10];
          ctx.moveTo(c1[0], c1[1]).lineTo(c2[0], c2[1]).lineTo(c3[0], c3[1]).lineTo(c4[0], c4[1]).closePath();
        },
      });
      echarts.graphic.registerShape("CubeLeft", CubeLeft);
      echarts.graphic.registerShape("CubeRight", CubeRight);
      echarts.graphic.registerShape("CubeTop", CubeTop);
      this.faultOption = {
        tooltip: {
          trigger: "axis",
          axisPointer: { type: "shadow" },
          formatter: function (params) {
            const item = params[1];
            return item.name + " : " + item.value;
          },
        },
        title: {
          text: "当前故障",
          top: 4,
          left: "center",
          textStyle: { color: "#fff", fontSize: 15, fontWeight: 500 },
        },
        grid: { left: 40, right: 40, bottom: 30, top: 80, containLabel: true },
        xAxis: {
          type: "category",
          data: ["空滤堵塞", "低油压", "低电压", "低液位"],
          axisLine: { show: false, lineStyle: { color: "white" } },
          offset: 0,
          axisTick: { show: false, length: 9, alignWithLabel: true, lineStyle: { color: "#7DFFFD" } },
          axisLabel: { show: true, fontSize: 10 },
        },
        yAxis: {
          type: "value",
          axisLine: { show: false, lineStyle: { color: "white" } },
          splitLine: { show: false },
          axisTick: { show: false },
          axisLabel: { show: false, fontSize: 16 },
          boundaryGap: ["20%", "20%"],
        },
        series: [
          {
            type: "custom",
            renderItem: function (params, api) {
              const location = api.coord([api.value(0), api.value(1)]);
              return {
                type: "group",
                children: [
                  {
                    type: "CubeLeft",
                    shape: { api, x: location[0], y: location[1], xAxisPoint: api.coord([api.value(0), 0]) },
                    style: { fill: "rgba(47,102,192,.27)" },
                  },
                  {
                    type: "CubeRight",
                    shape: { api, x: location[0], y: location[1], xAxisPoint: api.coord([api.value(0), 0]) },
                    style: { fill: "rgba(59,128,226,.27)" },
                  },
                  {
                    type: "CubeTop",
                    shape: { api, x: location[0], y: location[1], xAxisPoint: api.coord([api.value(0), 0]) },
                    style: { fill: "rgba(72,156,221,.27)" },
                  },
                ],
              };
            },
            data: [3000, 3000, 3000, 3000],
          },
          {
            type: "custom",
            renderItem: (params, api) => {
              const location = api.coord([api.value(0), api.value(1)]);
              var color = api.value(1) > 2000
                ? "red"
                : new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "yellow" },
                  { offset: 1, color: "yellow" },
                ]);
              return {
                type: "group",
                children: [
                  {
                    type: "CubeLeft",
                    shape: {
                      api,
                      xValue: api.value(0),
                      yValue: api.value(1),
                      x: location[0],
                      y: location[1],
                      xAxisPoint: api.coord([api.value(0), 0]),
                    },
                    style: { fill: color },
                  },
                  {
                    type: "CubeRight",
                    shape: {
                      api,
                      xValue: api.value(0),
                      yValue: api.value(1),
                      x: location[0],
                      y: location[1],
                      xAxisPoint: api.coord([api.value(0), 0]),
                    },
                    style: { fill: color },
                  },
                  {
                    type: "CubeTop",
                    shape: {
                      api,
                      xValue: api.value(0),
                      yValue: api.value(1),
                      x: location[0],
                      y: location[1],
                      xAxisPoint: api.coord([api.value(0), 0]),
                    },
                    style: {
                      fill: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        { offset: 0, color: "rgba(47,102,192,.27)" },
                        { offset: 1, color: "rgba(47,102,192,.27)" },
                      ]),
                    },
                  },
                ],
              };
            },
            data: [filterPluggingCount, lowOilCount, lowPowerCount, lowLiquidLevelCount],
          },
          {
            type: "bar",
            label: {
              normal: {
                show: true,
                position: "top",
                fontSize: 14,
                color: "#15cbdb",
                offset: [2, -60],
                formatter: function (params) {
                  return params.value + " 次";
                },
              },
            },
            itemStyle: { color: "transparent" },
            tooltip: {},
            data: [filterPluggingCount, lowOilCount, lowPowerCount, lowLiquidLevelCount],
          },
        ],
      };
      myLine.setOption(this.faultOption);
      myLine.on("click", (e) => {
        var name = e.name;
        if (name) {
          this.$router.push({ name: "FaultManagement", params: { name: name } });
        }
      });
    },
  },
};
